import { makeAutoObservable } from 'mobx';
import { ICredentialsStore } from '../../integration-store';
import { ISendcloudReturnsCredentialsModel } from '../../../../../../models/IntegrationsTypes';

class SendcloudReturnsCredentialsStore implements ICredentialsStore {
    private _changes: ISendcloudReturnsCredentialsModel = {} as ISendcloudReturnsCredentialsModel;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }
    public get brandId() { return this._changes.brand_id; };
    public get apiKey() { return this._changes.api_key; };
    public get apiSecret() { return this._changes.api_secret; };

    setInternalName(value: string) {
        this._changes.internal_name = value;
    };
    
    setApiKey(value: string) {
        this._changes.api_key = value;
    };

    setApiSecret(value: string) {
        this._changes.api_secret = value;
    };

    setBrandId(value: string) {
        this._changes.brand_id = value;
    };

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }
}

export default SendcloudReturnsCredentialsStore;
